namespace TabAurous.Production {
    export namespace WhatIsWhereService {
        export const baseUrl = 'Production/WhatIsWhere';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<WIPMovementRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/WhatIsWhere/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>WhatIsWhereService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
